import Vue from 'vue'
import client from '@/api/client'
import filterPageItemsQuery from '@/api/gql/filter-page/query/filter-page-items.gql'
import filterPageItemRecommendationsQuery from '@/api/gql/filter-page/query/filter-page-item-recommendations.gql'
import { formatTags, formatVariants } from '@/components/FilterPage/transformation-helpers'

export const RECOMMENDATION_BLOCK_IDS = {
  miniCart: 'mini-cart',
  productPage: 'product-page',
}

export function fetchItems(payload) {
  return payload?.skus?.length
    ? fetchFilterPageItems(payload)
    : fetchFilterPageItemRecommendations(payload)
}

function fetchFilterPageItems({ skus = [] } = {}) {
  return client
    .query({
      query: filterPageItemsQuery,
      variables: { skus },
    })
    .then(({ data }) => formatFilterPageItems(data.filterPageItems))
}

function fetchFilterPageItemRecommendations({ excludeProductId = null } = {}) {
  return client
    .query({
      query: filterPageItemRecommendationsQuery,
      variables: { excludeProductId },
    })
    .then(({ data }) => formatFilterPageItems(data.filterPageItemRecommendations))
}

function formatFilterPageItems(items) {
  return items.map(item => formatVariants(formatTags(item)))
}

function setStateProperty(state, property, payload) {
  state[property] = { ...state[property], ...payload }
}

function getStateById(state, id) {
  return {
    headline: state.headline[id] || '',
    skus: state.skus[id] || [],
    items: state.items[id] || [],
    isInitialisedByDy: state.isInitialisedByDy[id] || false,
  }
}

export default {
  namespaced: true,
  state: {
    headline: {},
    skus: {},
    items: {},
    isInitialisedByDy: {},
  },

  mutations: {
    // headline, skus and isInitialisedByDy are set from the DY recommendation widget
    setState(state, payload) {
      if (!payload.id) return

      for (const property in payload) {
        if (state[property]) Vue.set(state[property], payload.id, payload[property])
      }
    },

    setHeadline(state, payload) {
      setStateProperty(state, 'headline', payload)
    },

    setSkus(state, payload) {
      setStateProperty(state, 'skus', payload)
    },
  },

  actions: {
    fetchData({ commit }, payload) {
      return new Promise((resolve, reject) => {
        if (!Vue.$dyClient.shouldUpdateRecommendation) return resolve(null)
        fetchItems(payload)
          .then(items => {
            commit('setState', {
              id: payload.id,
              items,
            })
            resolve(items)
          })
          .catch(error => reject(error))
      })
    },

    fetchProductPageRecommendations({ dispatch }, payload) {
      const id = RECOMMENDATION_BLOCK_IDS.productPage
      return dispatch('fetchData', {
        id,
        skus: payload.skus,
        excludeProductId: payload.excludeProductId,
      })
    },
  },

  getters: {
    productPageState: state => getStateById(state, RECOMMENDATION_BLOCK_IDS.productPage),
  },
}
